var _path, _circle, _path2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 120,
    viewBox: "0 0 133 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.4092 59.7948L102.226 70.6115L126.999 45.8379",
    stroke: "white",
    strokeWidth: 11.1905,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "#EBE14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 29.814L60.5 68.0034",
    stroke: "white",
    strokeWidth: 14.2884,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5011,
    cy: 89.8715,
    r: 8.25795,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMessage);
export default __webpack_public_path__ + "static/media/ReportMessage.f317d7aa4b425104f8631ea9f370d6bc.svg";
export { ForwardRef as ReactComponent };